import { styled } from "styled-components";

import SectionTitle from "../atoms/SectionTitle";

import AboutImage from "../../assets/icons/about.svg";
import Section, { StyledSectionImage } from "../molecules/Section";

const About = () => {
  return (
    <Section id="about">
      <SectionTitle title="about me" />
      <StyledSectionImage src={AboutImage} alt="" />

      <StyledAboutText>
        I’m frontend developer dedicated to crafting websites and apps with an
        <span> unwavering</span> focus on <span>precision</span> and{" "}
        <span>attention</span> to <span>detail</span>.
        {/* <br /> */}
        {/* Interested in <span>Machine Learning</span>. */}
      </StyledAboutText>
    </Section>
  );
};

const StyledAboutText = styled.p`
  font-size: 32px;
  span {
    color: ${({ theme }) => theme.colors.highlightedText};
  }

  @media (min-width: 750px) {
    font-size: 38px;
  }
  @media (min-width: 1000px) {
    font-size: 48px;
  }
`;

export default About;
